/** 活动图：OSS 公共读裸链 */
export const UPLOAD_PUBLIC_BASE =
  'https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/upload'

/** 静态站图：OSS 公共读（对象 key = images/{文件名}） */
export const IMAGE_PUBLIC_BASE =
  'https://oss-pai-s2lxmtw6mbk6ofo9ye-cn-shanghai.oss-cn-shanghai.aliyuncs.com/images'

const LEGACY_UPLOAD_HOST = /^https?:\/\/(?:www\.)?wvxvb\.cn\/upload\/?/i
const LEGACY_IMAGES_HOST = /^https?:\/\/(?:www\.)?wvxvb\.cn\/images\/?/i
const APP_OSS_PROXY = /^https?:\/\/[^/]+\/app\/oss\/file\/upload\/?/i

export function resolveUploadUrl(raw) {
  const v = String(raw == null ? '' : raw).trim()
  if (!v) return ''
  if (LEGACY_UPLOAD_HOST.test(v) || APP_OSS_PROXY.test(v)) {
    const name = v
      .replace(LEGACY_UPLOAD_HOST, '')
      .replace(APP_OSS_PROXY, '')
      .replace(/^\/+/, '')
    return name ? `${UPLOAD_PUBLIC_BASE}/${name}` : UPLOAD_PUBLIC_BASE
  }
  if (LEGACY_IMAGES_HOST.test(v)) {
    return resolveImageAssetUrl(v)
  }
  if (/^https?:\/\//i.test(v)) return v
  const name = v.replace(/^\/+/, '').replace(/^upload\//i, '')
  return `${UPLOAD_PUBLIC_BASE}/${name}`
}

/** 旧站 /images 完整 URL 或相对文件名 → OSS images 裸链 */
export function resolveImageAssetUrl(raw) {
  const v = String(raw == null ? '' : raw).trim()
  if (!v) return ''
  if (LEGACY_IMAGES_HOST.test(v)) {
    const name = v.replace(LEGACY_IMAGES_HOST, '').replace(/^\/+/, '')
    return name ? `${IMAGE_PUBLIC_BASE}/${name}` : IMAGE_PUBLIC_BASE
  }
  if (/^https?:\/\//i.test(v)) return v
  const name = v.replace(/^\/+/, '').replace(/^images\//i, '')
  return `${IMAGE_PUBLIC_BASE}/${name}`
}
